import React from 'react';
class ErrorComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {errorMessages: this.props.errorMessages || [] }
    }

    componentDidUpdate(nextProps) {
        if (nextProps.errorMessages !== this.state.errorMessages) {
            this.setState({errorMessages: nextProps.errorMessages})
        }
    }
    render () {
        console.log(this.state.errorMessages)
        return (<div style={{position: "absolute", width: "100vw", display: 'flex',justifyContent: "center", alignItems: "center", flexDirection: 'column'}}>
            {this.state.errorMessages.map((el, i) => {
                return (<h2 key={i} style={{color: 'red'}}>{el.errorMessage}</h2>)
            })}
        </div>)
    }
}

export default (ErrorComponent)